import { render, staticRenderFns } from "./ValidatorRow.vue?vue&type=template&id=66e6b5f6&scoped=true&"
import script from "./ValidatorRow.vue?vue&type=script&lang=ts&"
export * from "./ValidatorRow.vue?vue&type=script&lang=ts&"
import style0 from "./ValidatorRow.vue?vue&type=style&index=0&id=66e6b5f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e6b5f6",
  null
  
)

export default component.exports